module.exports = __webpack_public_path__ + "static/media/logo-with-text.b3caab8a.svg";